<template>
  <div class="home-preview" :class="[deviceType]">
    <div class="preview-header">
      <div class="preview-dot"></div>
      <div class="preview-title">Combination Preview</div>
    </div>
    <div class="preview-tabs">
      <div class="tab-container" ref="tabContainer">
        <div class="slider" :style="sliderStyle"></div>
        <div v-for="(tab, index) in tabs" :key="index" class="tab"
          :class="{ 'active': activeTabIndex === index }" @click="setActiveTab(index)"
          @mouseenter="hoveredTabIndex = index" @mouseleave="hoveredTabIndex = null">
          <div class="tab-text">{{ tab.title }}</div>
        </div>
      </div>
      <div class="view-more" @mouseenter="isViewMoreHovered = true"
        @mouseleave="isViewMoreHovered = false" :class="{ 'hovered': isViewMoreHovered }"
        @click="navigateToNames" v-if="deviceType !== 'mobile'">
        <span>View More</span>
        <img src="@/assets/default/arrow-right.svg" alt="arrow right" class="arrow-icon" />
      </div>
    </div>
    <div class="preview-cards">
      <router-link v-for="(card, index) in cards" :key="index"
        :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div" class="name-card-link">
        <div class="name-card" @mouseenter="hoveredCard = index" @mouseleave="hoveredCard = null">
          <div class="card-header">
            <div class="card-name">{{ card.name }}</div>
            <div class="card-gender-icon">
              <img :src="card.genderIcon" alt="gender icon" />
            </div>
          </div>
          <div class="card-pronunciation">{{ card.pronunciation }}</div>
          <div class="card-divider"></div>
          <div class="card-details">
            <div class="card-detail">
              <div class="detail-label">Style</div>
              <div class="detail-value">{{ card.style }}</div>
            </div>
            <div class="card-detail">
              <div class="detail-label">Meaning</div>
              <!-- <div class="detail-value">{{ card.meaning }}</div> -->
              <div class="detail-value">
                <span v-for="item in card.meaningList" :key="item">{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="card-divider"></div>
          <div class="card-popularity">
            <div class="popularity-label">US Popularity</div>
            <div class="popularity-value">{{ card.popularity }}</div>
          </div>
        </div>
      </router-link>
    </div>

    <div class="view-more" @click="navigateToNames" v-if="deviceType === 'mobile'">
      <div class="view-more-text">View More</div>
      <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="view-more-icon" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomePreview',
  data () {
    return {
      activeTabIndex: 0,
      hoveredTabIndex: null,
      hoveredCard: null,
      isViewMoreHovered: false,
      sliderPosition: { left: '8px', width: '220px' },
      tabs: [
        {
          title: 'Elegant Boy Names with Hope',
          params: {
            gender: ['Boy'],
            meaning: ['Hope'],
            style: 'Elegant',
          }
        },
        {
          title: 'Classic Boy Names with Strength and Wisdom',
          params: {
            gender: ['Boy'],
            meaning: ['Strength', 'Wisdom'],
            style: 'Classic'
          }
        },
        {
          title: 'Vintage Boy Names Filled with Love and Hope',
          params: {
            gender: ['Boy'],
            meaning: ['Love', 'Hope'],
            style: 'Vintage'
          }
        }
      ],
      cards: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ]),
    sliderStyle () {
      return this.sliderPosition;
    },
    currentTab () {
      return this.tabs[this.activeTabIndex] || {};
    }
  },
  methods: {
    setActiveTab (index) {
      this.activeTabIndex = index;

      this.$nextTick(() => {
        this.updateSliderPosition();
        this.fetchPreviewNames();
      });
    },
    updateSliderPosition () {
      const defaultStyle = { left: '8px', width: '220px' };

      try {
        const tabContainer = this.$refs.tabContainer;
        console.log('tabContainer:', tabContainer);
        if (!tabContainer) {
          console.log('tabContainer ref不存在');
          this.sliderPosition = defaultStyle;
          return;
        }

        const tabs = tabContainer.querySelectorAll('.tab');
        console.log('tabs:', tabs, 'activeTabIndex:', this.activeTabIndex);
        if (!tabs || tabs.length === 0) {
          console.log('没有找到tab元素');
          this.sliderPosition = defaultStyle;
          return;
        }

        const activeTab = tabs[this.activeTabIndex];
        console.log('activeTab:', activeTab);
        if (!activeTab) {
          console.log('没有找到激活的tab');
          this.sliderPosition = defaultStyle;
          return;
        }

        const containerRect = tabContainer.getBoundingClientRect();
        const activeTabRect = activeTab.getBoundingClientRect();
        console.log('containerRect:', containerRect, 'activeTabRect:', activeTabRect);

        const left = activeTabRect.left - containerRect.left;
        const width = activeTabRect.width;
        console.log('计算结果 - left:', left, 'width:', width);

        this.sliderPosition = {
          left: `${left}px`,
          width: `${width}px`
        };
        console.log('更新后的sliderPosition:', this.sliderPosition);
      } catch (error) {
        console.error('Error calculating slider style:', error);
        this.sliderPosition = defaultStyle;
      }
    },
    handleResize () {
      this.updateSliderPosition();
    },
    async fetchPreviewNames () {
      try {
        const activeTab = this.tabs[this.activeTabIndex];
        if (!activeTab) return;

        // Base params for the request
        const apiParams = {
          pageSize: '4',
          pageNum: '1',
          ...activeTab.params
        };

        // Add origin from domainConfig
        if (this.domainConfig && this.domainConfig.origin) {
          apiParams.origin = this.domainConfig.origin;
        }

        // Make a single API request
        const response = await this.$global.server.postAPI({
          method: 'post',
          params: apiParams,
          url: '/name/page',
        });

        if (response && response.data && response.data.list) {
          // 将接口返回数据转换为组件所需格式
          this.cards = response.data.list.map(item => {
            return {
              name: item.name || '',
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || '',
              style: item.style || '',
              meaning: item.meaning || '',
              meaningList: item.meaningList || [],
              popularity: item.popularity || '',
              id: item.id || ''
            };
          });
          console.log('Preview names fetched successfully:', response.data);
        } else {
          this.cards = [];
        }
      } catch (error) {
        console.error('Error fetching preview names:', error);
        this.cards = [];
      }
    },
    navigateToNames () {
      this.$router.push('/names');
    },
  },
  mounted () {
    setTimeout(() => {
      this.setActiveTab(0);
      this.updateSliderPosition();
      this.fetchPreviewNames();
    }, 300);

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-preview {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.preview-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.preview-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.preview-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.preview-tabs {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		.tab-container {
			background: #f7f3f3;
			border-radius: rem(100);
			padding: rem(8);
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			position: relative;

			.slider {
				position: absolute;
				top: rem(8);
				left: rem(8); /* 确保初始位置正确 */
				height: calc(100% - rem(16));
				background: linear-gradient(90.94deg, rgba(163, 25, 132, 0.1) 0%, rgba(163, 25, 132, 0) 100%), #ffffff;
				border-radius: rem(100);
				border: rem(2) solid #ffffff;
				box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
				transition: all 0.3s ease;
			}

			.tab {
				border-radius: rem(100);
				padding: rem(12) rem(20);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				position: relative;
				z-index: 1;
				transition: all 0.3s ease;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;

				&:not(.active) {
					width: rem(220);
					max-width: rem(220);

					.tab-text {
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						display: block;
						width: 100%;
					}

					&:hover .tab-text {
						color: #a31984;
						font-weight: 600;
					}
				}

				&.active {
					max-width: none;

					.tab-text {
						color: #a31984;
						font-weight: 800;
					}
				}

				.tab-text {
					color: #374674;
					text-align: left;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 400;
					transition: all 0.3s ease;
				}
			}
		}

		.view-more {
			border-radius: rem(12);
			border: rem(1) solid transparent;
			padding: rem(8) rem(16);
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease;

			&.hovered {
				opacity: 0.8;
			}

			span {
				color: #a31984;
				text-align: center;
				font-size: rem(16);
				line-height: rem(16);
				font-weight: 700;
			}

			.arrow-icon {
				width: rem(6);
				height: rem(12);
			}
		}
	}

	.preview-cards {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		.name-card-link {
			text-decoration: none;
		}

		.name-card {
			background: linear-gradient(101.3deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.6) 70%, rgba(255, 255, 255, 0) 100%);
			border-radius: rem(36);
			border: rem(1) solid rgba(3, 19, 58, 0.04);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			width: rem(252);
			height: rem(274);
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			cursor: pointer;

			&.active,
			&:hover {
				border-color: #a31984;
				box-shadow: none;
			}

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-name {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}

				.card-gender-icon {
					width: rem(16);
					height: rem(16);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.card-pronunciation {
				background: #f7f3f3;
				border-radius: rem(8);
				padding: rem(4) rem(8);
				color: #03133a;
				text-align: left;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
				font-style: italic;
				position: relative;
			}

			.card-divider {
				border-top: rem(1) dashed rgba(3, 19, 58, 0.1);
				align-self: stretch;
				height: 0;
				position: relative;
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(16);
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-detail {
					display: flex;
					flex-direction: column;
					gap: rem(8);
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.detail-label {
						color: #a31984;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 200;
						position: relative;
						align-self: stretch;
					}

					.detail-value {
						color: #03133a;
						text-align: left;
						font-size: rem(13);
						line-height: rem(14);
						font-weight: 700;
						position: relative;
						align-self: stretch;
						display: flex;
						gap: rem(7);
					}
				}
			}

			.card-popularity {
				border-radius: rem(8);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.popularity-label {
					color: #a31984;
					text-align: left;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 200;
					position: relative;
				}

				.popularity-value {
					background: #a31984;
					border-radius: rem(8);
					padding: rem(4) rem(8);
					color: #ffffff;
					text-align: center;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 900;
					font-style: italic;
					height: rem(22);
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-preview {
		padding: rem(60) 0;

		.preview-header {
			padding: 0 rem(16);
		}

		.preview-tabs {
			padding: 0 rem(16);
			flex-direction: column;
			gap: rem(16);
			align-items: stretch;

			.tab-container {
				width: 100%;
				overflow-x: visible;
				padding: 0;
				background: transparent;
				flex-direction: column;
				gap: rem(8);
				border-radius: rem(36);
				background: #f7f3f3;
				padding: rem(8);

				.slider {
					display: none;
				}

				.tab {
					flex-shrink: 0;
					width: 100%;
					max-width: none;
					justify-content: center;
					background: #ffffff;
					padding: rem(12) rem(24);
					height: rem(56);
					border-radius: rem(100);
					border: rem(2) solid #ffffff;

					.tab-text {
						white-space: normal;
						text-overflow: unset;
						overflow: visible;
						width: auto;
						text-align: center;
					}

					&:not(.active) {
						width: 100%;
						max-width: none;
					}

					&.active {
						background: linear-gradient(90.94deg, rgba(163, 25, 132, 0.1) 0%, rgba(163, 25, 132, 0) 100%), #ffffff;
						box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
					}
				}
			}
		}

		.preview-cards {
			padding: 0 rem(16) rem(8);
			flex-direction: row;
			gap: rem(16);
			overflow-x: auto;
			&::-webkit-scrollbar {
				display: none;
			}
			-ms-overflow-style: none; /* IE and Edge */
			scrollbar-width: none; /* Firefox */

			.name-card {
				width: rem(252);
				height: auto;
				flex-shrink: 0;
			}
		}

		.view-more {
			border-radius: rem(12);
			border: rem(1) solid transparent;
			padding: rem(8) rem(16);
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-end;
			position: relative;
			width: 100%;
			cursor: pointer;
			transition: all 0.3s ease;

			&:hover {
				border-color: #a31984;
			}

			.view-more-text {
				color: #a31984;
				text-align: center;
				font-size: rem(16);
				line-height: rem(16);
				font-weight: 700;
				position: relative;
			}

			.view-more-icon {
				width: rem(6);
				height: rem(12);
			}
		}
	}
}
</style> 